<script setup lang="ts">
import type { AppStudioModalControls } from '../../../Scripts/Components/Modal/app-studio-modal';
import Vimeo from '@vimeo/player';
import { nextTick, ref } from 'vue';

import StModal from '../../../Scripts/Components/Modal/StModal.vue';

defineOptions({ name: 'StHelpVideoModal' });

const props = defineProps<{
    refId: string;
    title: string;
    vimeoVideoUrl: string;
}>();

const modal = ref<AppStudioModalControls>();
const vimeoPlayer = ref<HTMLElement | null>(null);
const showLoadingSpinner = ref(false);
const failedToLoadVideo = ref(false);

function hide(): void {
    modal.value?.hide();
}

async function show(): Promise<void> {
    showLoadingSpinner.value = true;
    failedToLoadVideo.value = false;
    modal.value?.show();

    await nextTick();

    try {
        const player = new Vimeo(vimeoPlayer.value, {
            url: props.vimeoVideoUrl,
            autoplay: true
        });

        player.on('error', () => {
            showLoadingSpinner.value = false;
            failedToLoadVideo.value = true;
        });

        await player.ready();
        showLoadingSpinner.value = false;
    } catch (error) {
        console.error('Load help video error:', error);
        showLoadingSpinner.value = false;
        failedToLoadVideo.value = true;
    }
}

defineExpose({
    onHideHelpModal: hide,
    onShowHelpModal: show,
    show
});
</script>

<template>
    <StModal :id="refId" ref="modal" :hide-footer="true" size="xl" @close="hide">
        <template #title>{{ title }}</template>
        <div>
            <span v-if="showLoadingSpinner">
                <i class="fa fa-spinner fa-spin"></i>
                Loading help video...
            </span>
            <template v-else-if="failedToLoadVideo">Failed to load help video</template>
            <div class="ratio ratio-16x9">
                <div ref="vimeoPlayer"></div>
            </div>
        </div>
        <div class="form-actions">
            <a href="#" @click.prevent="hide">Close</a>
        </div>
    </StModal>
</template>
